import React, { useState } from "react";
import { ArrowRight, PlayCircle, MessageCircle } from "lucide-react";
import { useLeadModal } from "./LeadModalContext";
import VideoModal from "./VideoModal";

const DEMO_VIDEO_ID = "TSf32I2m1VE"; // ← replace with real Stori demo YouTube ID

export default function FinalCTA() {
  const { openModal } = useLeadModal();
  const [videoOpen, setVideoOpen] = useState(false);
  return (
    <section
      id="demo"
      data-testid="final-cta"
      className="relative py-28 lg:py-40 border-b border-stori-border overflow-hidden bg-stori-bg"
    >
      {/* Background effects */}
      <div className="absolute inset-0 grid-noise opacity-40 radial-mask" />
      <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-stori-cyan/15 rounded-full blur-[120px] pointer-events-none" />

      <div className="relative max-w-[1100px] mx-auto px-6 lg:px-10 text-center">
        <div className="label-eyebrow text-stori-cyan flex items-center justify-center gap-2">
          <span className="inline-block h-px w-10 bg-stori-cyan" />
          GET STARTED
          <span className="inline-block h-px w-10 bg-stori-cyan" />
        </div>

        <h2 className="mt-6 font-heading text-5xl sm:text-6xl lg:text-7xl font-semibold tracking-tight leading-[1.02] text-white">
          See the dashboard
          <br />
          <span className="text-stori-cyan cyan-text-glow">your team will actually use.</span>
        </h2>

        <p className="mt-8 text-lg lg:text-xl text-stori-muted max-w-2xl mx-auto leading-relaxed">
          Book a 20-minute demo. See real client dashboards, real playbooks,
          and the exact ROI calculator that convinced 27 countries of operators.
        </p>

        <div className="mt-12 flex flex-wrap items-center justify-center gap-3">
          <button
            type="button"
            onClick={() => setVideoOpen(true)}
            data-testid="final-cta-watch-demo"
            className="group inline-flex items-center gap-2 bg-stori-cyan text-black font-semibold px-7 py-4 rounded-md hover:bg-stori-cyanHover transition-all hover:translate-y-[-1px]"
          >
            <PlayCircle className="w-4 h-4" />
            Watch a demo
            <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5" />
          </button>
          <button
            type="button"
            onClick={() => openModal("trial_signup")}
            data-testid="final-cta-trial"
            className="inline-flex items-center gap-2 border border-stori-cyan/60 text-stori-cyan px-7 py-4 rounded-md hover:bg-stori-cyan/10 transition-colors font-medium"
          >
            Get started for free
          </button>
          <a
            href="mailto:meetstori@gmail.com"
            data-testid="final-cta-chat"
            className="inline-flex items-center gap-2 text-stori-muted hover:text-white px-4 py-4"
          >
            <MessageCircle className="w-4 h-4" />
            Chat with sales
          </a>
        </div>

        <div className="mt-14 flex flex-wrap items-center justify-center gap-x-10 gap-y-3 font-mono text-[10px] uppercase tracking-[0.2em] text-stori-muted">
          <span>· no credit card required</span>
          <span>· cancel anytime</span>
          <span>· gdpr + ccpa compliant</span>
          <span>· soc2 type ii</span>
        </div>
      </div>

      <VideoModal
        open={videoOpen}
        onClose={() => setVideoOpen(false)}
        videoId={DEMO_VIDEO_ID}
        title="Stori product demo"
      />
    </section>
  );
}
